import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import AttendanceHeader from '../../Components/attendance/AttendanceHeader';
import AttendanceFilters from '../../Components/attendance/AttendanceFilter';
import AttendanceTable from '../../Components/attendance/AttendanceTable';
import './annualAttendance.css';

const AnnualAttendance = () => {
  const [showLeavers, setShowLeavers] = useState(false);
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>([
    dayjs('2025-08-01'),
    dayjs('2025-09-30')
  ]);
  const [filters, setFilters] = useState({});

  const handleFiltersChange = (newFilters: any) => {
    setFilters(newFilters);
  };

  return (
    <div className="aa">
      <div className="aa-page">
        <AttendanceHeader />
        <AttendanceFilters
          showLea={showLeavers}
          onToggleLeavers={setShowLeavers}
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
          onFiltersChange={handleFiltersChange}
        />
        <AttendanceTable 
          showLeavers={showLeavers}
          filters={filters}
        />
      </div>
    </div>
  );
};

export default AnnualAttendance;